// extracted by mini-css-extract-plugin
module.exports = {"amazon-sale-D":"D_amazon-sale-D__eyBkK"};